import { IconButton, TextField } from "@mui/material";
import { KeyboardEventHandler, ReactNode, useState } from "react";
import * as React from "react";
import {SxProps} from "@mui/system";
import {FormikProps} from "formik";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

interface TextInputProps {
    label: string | ReactNode
    className?: string
    type?: 'text' | 'date' | 'number' | 'password'
    value?: string | number | null
    disabled?: boolean
    multiline?: boolean
    fullWidth?: boolean
    submitHappen?: boolean
    rows?: number
    name?: string
    error?: string | ReactNode
    sx?: SxProps
    onChange?: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>
    onBlur?: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>
    formik?: FormikProps<any>
    endAdorment?: ReactNode
    onKeyUp?: KeyboardEventHandler<HTMLDivElement>
}

export function TextInput({onKeyUp, className, error, fullWidth, onBlur, endAdorment, submitHappen, formik, rows, sx, type, label, multiline, disabled, value, name, onChange}: TextInputProps) {
    const [showPassword, setShowPassword] = useState(false);
    if(formik && !name) {
        alert("name not defined, while formik defined");
    }
    return <TextField
        sx={sx}
        className={className}
        onKeyUp={onKeyUp}
        fullWidth={fullWidth}
        name={name}
        type={type === 'password' && showPassword ? 'text' : type}
        rows={rows}
        //@ts-ignore
        value={(value === undefined ? (formik ? (formik.values[name!] || '') : '') : value)}
        multiline={multiline}
        disabled={disabled}
        label={label}
        onBlur={onBlur ? onBlur : (formik ? formik.handleBlur : undefined)}
        onChange={onChange ? onChange : (formik ? formik.handleChange : undefined)}
        variant={"outlined"}
        //@ts-ignore
        error={formik ? (submitHappen || formik.touched[name!]) && Boolean(formik.errors[name!]) : !!error}
        //@ts-ignore
        helperText={formik ? (submitHappen || formik.touched[name!]) && formik.errors[name!] : error}
        slotProps={{input: {
            endAdornment: endAdorment ? endAdorment : type === 'password' ?
                (showPassword
                    ? <IconButton onClick={() => setShowPassword(!showPassword)}><RemoveRedEyeOutlinedIcon color={"info"}/></IconButton>
                    : <IconButton onClick={() => setShowPassword(!showPassword)}><VisibilityOffOutlinedIcon color={"disabled"}/></IconButton>)
                : undefined
        }}}
    />
}